import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import InitialStep from '../components/InitialStep';
import Summary from '../components/Summary';
import Step from '../components/Step';
import Footer from '../components/Footer';
import { observer, pricingCalculator as store } from 'store';
import { useWindowResize } from 'utils/hooks';
import { pushCustomEvent } from 'utils/analytics';
import * as styles from './StepsContainer.module.scss';

function StepsContainer({ subtitle, sections, analyticsEvent }) {
  const { width } = useWindowResize();
  const stepsRefs = useRef([]);
  const [active, setActive] = useState(null);
  const [triggerValidation, setTriggerValidation] = useState(false);
  const [stepsWrapperHeight, setStepsWrapperHeight] = useState('auto');
  const { currentStep } = store;
  const firstStep = currentStep === 1;
  const activeSection = sections.find(({ id }) => id === active);
  const steps = activeSection?.steps;
  const lastStep = steps?.length + 1;

  useEffect(() => {
    setStepsWrapperHeight(`${stepsRefs.current[currentStep]?.offsetHeight + 1}px`);
  }, [currentStep, width]);

  const handleCalculatorBodyClick = () => {
    if (firstStep || !active) return;
    if (analyticsEvent && active) {
      pushCustomEvent(analyticsEvent, {
        action: 'engage-with-calculator',
        label: active,
      });
    }
  };

  return (
    <div className={styles.container} onClick={handleCalculatorBodyClick}>
      <div className={styles.stepsWrapper}>
        <div
          className={styles.contentWrapper}
          style={{
            '--wrapperHeight': stepsWrapperHeight,
          }}
        >
          <InitialStep
            ref={el => (stepsRefs.current[1] = el)}
            className={cn(styles.step, firstStep && styles.active)}
            active={active}
            setActive={setActive}
            triggerValidation={triggerValidation}
            setTriggerValidation={setTriggerValidation}
            subtitle={subtitle}
            sections={sections}
          />
          {steps?.map((step, i) => (
            <Step
              ref={el => (stepsRefs.current[i + 2] = el)}
              key={`${step?.title}-${i}`}
              {...step}
              currentStep={currentStep}
              lastStep={lastStep}
              className={cn(styles.step, !firstStep && currentStep === i + 2 && styles.active)}
            />
          ))}
        </div>
        <Footer
          id={active}
          steps={steps}
          active={active}
          setActive={setActive}
          setTriggerValidation={setTriggerValidation}
          firstStep={firstStep}
          lastStep={lastStep}
          analyticsEvent={analyticsEvent}
        />
      </div>
      <Summary firstStep={firstStep} currentStep={currentStep} activeSection={activeSection} />
    </div>
  );
}

export default observer(StepsContainer);
